import React, { useState, useEffect, Fragment } from "react";
import ReactSelect from "react-select";
import _ from "lodash";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import Firebase from "../../../firebasehelper";
import { default_content } from "../constants/default";
import MenuList from "../../../components/ContentUpload/MenuList";
import SingleValue from "../../../components/ContentUpload/SingleValue";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import { PostTopics, PostTypes } from "../constants/selections";
import { ContentTypes } from "../../../Constants/selections";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import {
  UPLOADING_VIDEO,
  UPLOADING_IMAGE,
  UPLOADING_GIF,
} from "../../../Constants/string";
import { compare } from "../constants/functions";

PostTopics.sort(compare);

const FeedContent = ({
  onChangeContent,
  trackModification,
  brand_name,
  isVisible,
  feed,
}) => {
  const [content, setContent] = useState(feed ? feed : default_content);
  const [modification, setModification] = useState({});
  const [loading, setLoading] = useState(false);
  const [types, setTypes] = useState(PostTopics.sort(compare));
  const [loading_script, setLoadingScript] = useState("");
  useEffect(() => {
    if (feed) {
      setContent(feed);
    }
  }, [feed]);
  useEffect(() => {
    onChangeContent(content);
  }, [content]);
  useEffect(() => {
    if (trackModification) trackModification(modification);
  }, [modification]);
  const handleChange = ({ target }) => {
    const { name, value } = target;
    const newContent = _.cloneDeep(content);
    newContent[name] = value;
    setContent(newContent);
    // modification tracking..
    let newModification = { ...modification, [name]: value };
    setModification(newModification);
  };
  const handleInputChange = (inputValue, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      const newTypes = [...PostTopics];
      newTypes.push(inputValue);
      setTypes(newTypes);
    }
  };
  const handleSelectType = (value) => {
    const newContent = _.cloneDeep(content);
    newContent["type"] = value.value;
    setContent(newContent);
    // modification tracking..
    let newModification = { ...modification, type: value.value };
    setModification(newModification);
  };
  const handleSelectTopic = (value) => {
    const newContent = _.cloneDeep(content);
    newContent["topic"] = value.value;
    setContent(newContent);
    // modification tracking..
    let newModification = { ...modification, topic: value.value };
    setModification(newModification);
  };
  const handleSelectContentType = (value) => {
    const newContent = _.cloneDeep(content);
    newContent["media_type"] = value.value;
    setContent(newContent);
    // modification tracking..
    let newModification = { ...modification, media_type: value.value };
    setModification(newModification);
  };
  const handleSetMediaURL = (imgURL) => {
    const newContent = _.cloneDeep(content);
    newContent["media_url"] = imgURL;
    setContent(newContent);
    // modification tracking..
    let newModification = { ...modification, media_url: imgURL };
    setModification(newModification);
  };

  const uploadContent = (contentType) => async (mediaContent) => {
    const uploadFolder = "posters/" + brand_name;
    const title = new Date().getTime().toString();
    if (contentType === GIF_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_GIF);
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      setLoading(false);
      handleSetMediaURL(gif_url);
    } else if (contentType === IMAGE_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_IMAGE);
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      setLoading(false);
      handleSetMediaURL(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoading(true);
      setLoadingScript(UPLOADING_VIDEO);
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setLoading(false);
            setLoadingScript("");
            handleSetMediaURL(downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      handleSetMediaURL(mediaContent);
    }
  };
  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };

  const handleUploadError = (error) => {
    setLoadingScript("");
    setLoading(false);
  };
  return (
    <div
      className={`${!isVisible ? "d-none" : ""} mt-3`}
      style={{ textAlign: "left", width: "100%" }}
    >
      <div className="form-group row">
        <div className="col-12">
          <ReactSelect
            value={
              content.type ? { label: content.type, value: content.type } : null
            }
            onChange={handleSelectType}
            options={PostTypes.map((obj) => ({
              value: obj,
              label: obj,
            }))}
            placeholder="Post type"
            isSearchable={false}
            components={{ MenuList, SingleValue }}
          ></ReactSelect>
        </div>
      </div>
      <div className="form-group row">
        <div className="col-12">
          <ReactSelect
            isSearchable={true}
            name="topic"
            value={
              content.topic
                ? { label: content.topic, value: content.topic }
                : null
            }
            onChange={handleSelectTopic}
            options={types.map((obj) => ({
              value: obj,
              label: obj,
            }))}
            placeholder="Post topic"
            onInputChange={handleInputChange}
            noOptionsMessage={() => "..."}
          ></ReactSelect>
        </div>
      </div>
      <div className="form-group row">
        <div className="col-12">
          <ReactSelect
            value={
              content.media_type
                ? { label: content.media_type, value: content.media_type }
                : null
            }
            onChange={handleSelectContentType}
            options={ContentTypes}
            placeholder="What content would you like to post?"
            isSearchable={false}
            components={{ MenuList, SingleValue }}
          ></ReactSelect>
        </div>
      </div>
      {content.media_type && (
        <div className="col-div mb-2">
          {content.media_type === YOUTUBE_URL && (
            <YoutubeInput
              onChangeContent={uploadContent(YOUTUBE_URL)}
              currentUrl={content.media_url}
            />
          )}
          {content.media_type === IMAGE_UPLOAD && (
            <ImageUpload
              onChangeContent={uploadContent(IMAGE_UPLOAD)}
              contentUrl={content.media_url}
            />
          )}
          {content.media_type === GIF_UPLOAD && (
            <ImageUpload
              isGif={true}
              onChangeContent={uploadContent(GIF_UPLOAD)}
              contentUrl={content.media_url}
            />
          )}
          {content.media_type === VIDEO_UPLOAD && (
            <VideoUpload
              onChangeContent={uploadContent(VIDEO_UPLOAD)}
              defaultVideo={content.media_url}
            />
          )}
        </div>
      )}
      <Fade
        in={loading}
        style={{
          transitionDelay: loading ? "800ms" : "0ms",
        }}
        unmountOnExit
      >
        <Fragment>
          <p>{loading_script}</p>
          <CircularProgress />
        </Fragment>
      </Fade>
      <div className="form-group row">
        <div className="col-12">
          <input
            type="text"
            name="title"
            className="form-control"
            placeholder="Post title, attention grabber..."
            value={content.title}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-12">
          <textarea
            className="form-control post_content "
            name="content"
            value={content.content}
            placeholder="Input description here.."
            maxLength="280"
            onChange={handleChange}
          ></textarea>
          <p className="bottom-small-text">Max characters: 280</p>
        </div>
      </div>
    </div>
  );
};
export default FeedContent;



// WEBPACK FOOTER //
// ./src/screens/Feeds/components/FeedContent.js